import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20composition%20of%20carefully%20arranged%20fashion%20accessories%20bags%20sunglasses%20belts%20and%20small%20leather%20goods%20on%20a%20warm%20sand%20colored%20linen%20surface%2C%20soft%20directional%20window%20light%20creating%20gentle%20shadows%2C%20editorial%20catalog%20styling%2C%20refined%20neutral%20palette%20with%20touches%20of%20olive%20green%20and%20terracotta%2C%20sophisticated%20minimal%20aesthetic%2C%20no%20text%2C%20no%20logos%2C%20gallery%20quality%20product%20photography&width=1600&height=900&seq=hero-fresh-v2&orientation=landscape"
          alt="Curated fashion products flat lay"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-16 lg:px-24">
        <div className="max-w-[700px]">
          <p className="text-white/70 text-xs md:text-sm font-label tracking-[0.2em] uppercase mb-4">
            Curated Product Database
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.08] mb-6">
            Hipobuy Spreadsheet
            <br />
            <span className="text-white/85 font-normal italic">The Ultimate Product</span>
            <br />
            <span className="text-white/85">Finder Database</span>
          </h1>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-[540px] mb-8">
            Discover thousands of curated products, verified finds, shopping guides, and comparison resources with the most complete Hipobuy Spreadsheet platform.
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              Explore Hipobuy Sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <Link
              to="/article/hipobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              View Latest Guides
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
          <div className="flex flex-wrap items-center gap-5 mt-8">
            {['Updated Frequently', 'Community Driven', 'Detailed Reviews', 'Safe Shopping Tips'].map((badge) => (
              <span key={badge} className="flex items-center gap-1.5 text-white/65 text-xs">
                <i className="ri-check-line text-accent-400 text-sm"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}